import FlashcardItem from './FlashcardItem.jsx'

/**
 * FlashcardList component renders a list of flashcards.
 * Manages reveal state and passes update/delete handlers to items.
 *
 * @param {Object} props - Component props
 * @param {Array<Object>} props.cards - Array of flashcard objects
 * @param {Set<string>} props.revealedIds - Set of revealed flashcard IDs
 * @param {Function} props.onReveal - Callback to reveal a flashcard
 * @param {Function} props.onUpdate - Callback to update a flashcard
 * @param {Function} props.onDelete - Callback to delete a flashcard
 * @param {Set<string>} props.mutatingIds - Set of IDs being deleted or updated
 * @returns {React.ReactElement} Flashcard list
 */
export default function FlashcardList({
  cards,
  revealedIds,
  onReveal,
  onUpdate,
  onDelete,
  mutatingIds,
}) {
  return (
    <ul className="flashcard-list">
      {cards.map((card) => (
        <li key={card.id} className="flashcard-list__item">
          <FlashcardItem
            card={card}
            isRevealed={revealedIds.has(card.id)}
            onReveal={onReveal}
            onUpdate={onUpdate}
            onDelete={onDelete}
            isDeleting={mutatingIds.has(card.id)}
            isUpdating={mutatingIds.has(card.id)}
          />
        </li>
      ))}
    </ul>
  )
}
